export const componentName = 'B2bSwapDialog';
